const svgIcons = require("../../../../config/inlinesvg.json");

/**
 * Update content when cart is empty
 * @param {String} emptyMsg - Empty cart resource message
 */
function updateCartContent(emptyMsg) {
    $(".cart").addClass("cart-empty");
    $(".cart .cart-listing-header-inner").empty().append("<p class='text-center cart-empty-text'>" + emptyMsg + "</p> ");
    $(".cart .col-12").removeClass("col-lg-8");
}

module.exports = {
    /**
     * Clears coupon error messages and removes is-invalid class
     * @param {void}
     */
    clearCouponError: function() {
        $(".coupon-missing-error").hide();
        $(".coupon-error-message").empty();
        $(".promo-code-form").find(".form-control").removeClass("is-invalid");
    },

    /**
     * re-renders the order totals and the number of items in the cart
     * @param {Object} data - AJAX response from the server
     */
    updateCartTotals: function(data) {
        var $minicartQtyResource = $(".minicart-quantity").attr("data-resource");
        var $minicartQty = data.numItems < 100 ? data.numItems : $minicartQtyResource;
        var isNetPrice = data.totals.totalNetPrice && data.totals.totalNetPrice !== "-";
        var hasShippingNetPrice = data.totals.shippingTotalNetPrice && data.totals.shippingTotalNetPrice !== "-";
        var shippingCost = hasShippingNetPrice
            ? data.totals.shippingTotalNetPrice
            : data.totals.totalShippingCost;

        if (hasShippingNetPrice && data.totals.totalshippingCostWithDiscountValue === 0) {
            shippingCost = $(".shipping-cost").data("free-msg");
        }

        $(".cart-items-number").empty().append(data.resources.numberOfItems);
        $(".shipping-cost").empty().append(shippingCost);
        $(".tax-total").empty().append(data.totals.totalTax);
        $(".grand-total").empty().append(data.totals.grandTotal);
        $(".sub-total").empty().append(isNetPrice ? data.totals.totalNetPrice : data.totals.subTotalAdjustedFormatted);
        $(".cart-totals-container .sub-total").empty().append(isNetPrice ? data.totals.totalNetPrice : data.totals.subTotal);
        $(".minicart-quantity").empty().append($minicartQty);
        $(".minicart-title span").empty().append(`(${data.resources.numberOfItems})`);
        $(".minicart-link").attr({
            "data-minicart-items": $minicartQty
        });
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $(".js-order-discount").removeClass("hide-order-discount");
            $(".order-discount-total").empty()
                .append("- " + data.totals.orderLevelDiscountTotal.formatted);
        } else {
            $(".js-order-discount").addClass("hide-order-discount");
        }

        if (data.totals.shippingLevelDiscountTotal.value > 0) {
            $(".shipping-discount").removeClass("hide-shipping-discount");
            $(".shipping-discount-total").empty().append("- " +
                data.totals.shippingLevelDiscountTotal.formatted);
        } else {
            $(".shipping-discount").addClass("hide-shipping-discount");
        }

        if (data.totals.loyaltyDiscount) {
            $(".js-loyalty-discount").empty().append("- " + data.totals.loyaltyDiscount.formatted);
            if (data.totals.realTimeDiscount) {
                $(".loyalty-discount").addClass("including-realtime-discount");
            }
        }
        $(".loyalty-discount").toggleClass("d-none", !data.totals.loyaltyDiscount);
        if (data.totals.realTimeDiscount) {
            $(".js-realtime-discount").empty().append("- " + data.totals.realTimeDiscount.formatted);
        }
        $(".realtime-discount").toggleClass("d-none", !data.totals.realTimeDiscount);

        data.items.forEach(function (item) {
            if (data.totals.orderLevelDiscountTotal.value > 0) {
                $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
            }
            if (item.renderedPromotions) {
                $(".item-" + item.UUID).empty().append(item.renderedPromotions);
            } else {
                $(".item-" + item.UUID).empty();
            }

            if (item.available) {
                $(".uuid-" + item.UUID + " .unit-price").empty().append(item.priceTotal.renderedPrice);
                $(".line-item-price-" + item.UUID + " .unit-price").empty().append(item.priceTotal.renderedPrice);
                $(".item-total-" + item.UUID).empty().append(item.priceTotal.renderedPrice);
            }
        });
    },

    /**
     * appends params to a url
     * @param {string} url - Original url
     * @param {Object} params - Parameters to append
     * @returns {string} result url with appended parameters
     */
    appendToUrl: function (url, params) {
        var newUrl = url;
        newUrl += (newUrl.indexOf("?") !== -1 ? "&" : "?") + Object.keys(params).map(function (key) {
            return key + "=" + encodeURIComponent(params[key]);
        }).join("&");

        return newUrl;
    },

    /**
     * Checks whether the basket is valid. if invalid displays error message and disables
     * checkout button
     * @param {Object} data - AJAX response from the server
     */
    validateBasket: function (data) {
        const $cartError = $(".cart-error");
        var $minicartQtyResource = $(".minicart-quantity").attr("data-resource");
        var $minicartQty = data.numItems < 100 ? data.numItems : $minicartQtyResource;

        if (data.valid.error) {
            $cartError.empty();
            if (data.valid.message) {
                $cartError.html(`<div class="valid-cart-error" role="alert">${data.valid.message}</div>`);
            } else {
                updateCartContent(data.resources.emptyCartMsg);
                $(".number-of-items").empty().append(data.resources.numberOfItems);
                $(".minicart-quantity").empty().append($minicartQty);
                $(".minicart-link").attr({
                    "data-minicart-items": $minicartQty
                });
                $(".minicart-popover").empty().removeClass("show");
            }
            if (data.valid.checkoutContinueError) {
                $(".checkout-btn").addClass("disabled");
            }
        } else {
            $cartError.empty();
            $(".checkout-btn").removeClass("disabled");
        }
    },

    /**
     * re-renders the order totals and the number of items in the cart
     * @param {Object} message - Error message to display
     */
    createErrorNotification: function (message) {
        var errorHtml = "<div class='alert-dismissible valid-cart-error d-inline-block' role='alert'>" +
            message + "</div>";

        $(".cart-error").append(errorHtml);
    },

    /**
     * re-renders the approaching discount messages
     * @param {Object} approachingDiscounts - updated approaching discounts for the cart
     */
    updateApproachingDiscounts: function (approachingDiscounts) {
        const $approachingDiscounts = $(".approaching-discounts");
        let html = "";

        $approachingDiscounts.empty();
        if (approachingDiscounts.length > 0) {
            approachingDiscounts.forEach(function (item) {
                html += `<div class="cart-promo-truck-icon d-flex align-items-center justify-content-center">
                    <span class="mr-3">${svgIcons.truck}</span>
                    <span>${item.discountMsg}</span></div>`;
            });
        }
        $approachingDiscounts.append(html);
    },

    updateCartContent: updateCartContent
};
